import { makeTypeMetadataEntriesFetchUrl } from './cacheKeys';
import { getTypeMetadataQuickFetches, takeTypeMetadataQuickFetch } from './typeMetadataQuickFetch';
import { keyEntriesByAppSettings } from './keyEntriesByAppSettings';
import { batchScheduler } from 'batch-promise';
import { unwrapResult } from './unwrapResult';
const maybeFetchTypeEntries = ({
  appSettingNames,
  httpClient
}) => {
  if (appSettingNames.length === 0) {
    return Promise.resolve({});
  }
  return httpClient.post(makeTypeMetadataEntriesFetchUrl(), {
    data: appSettingNames
  }).then(keyEntriesByAppSettings);
};
const fetchTypeMetadataEntriesWithQuickFetch = async ({
  appSettingNames,
  httpClient
}) => {
  const quickFetches = getTypeMetadataQuickFetches();
  const batchFetch = maybeFetchTypeEntries({
    httpClient,
    appSettingNames: appSettingNames.filter(appSettingName => !quickFetches.has(appSettingName))
  });
  const results = await Promise.allSettled(appSettingNames.map(appSettingName => {
    const quickFetched = takeTypeMetadataQuickFetch(appSettingName);
    return (!quickFetched ? batchFetch : quickFetched.catch(() => maybeFetchTypeEntries({
      httpClient,
      appSettingNames: [appSettingName]
    }))).then(result => result[appSettingName]);
  }));
  return Object.fromEntries(appSettingNames.map((name, index) => [name, results[index]]));
};
export const batchedTypeMetadataRequest = batchScheduler().read().identity(req => req.appSettingName).partition(({
  httpClient
}) => httpClient).execute((requestMap, client) => fetchTypeMetadataEntriesWithQuickFetch({
  appSettingNames: Object.keys(requestMap),
  httpClient: client
})).extract(({
  response,
  identity
}) => response[identity] ? unwrapResult(response[identity]) : null).window(10);